import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiActionFigureGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-action-figure-generator',
			name: 'AI Action Figure Generator - Turn Photo into Figurine | Lift',
			description:
				"Create your AI action figure from any photo in seconds with Lift's generator. Turn yourself into a trending figurine with realistic packaging and toy-style effects. No watermark Try it now online!",
			url: 'https://liftapp.ai/ai-action-figure-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-action-figure-generator#product' },
				{ '@id': 'https://liftapp.ai/ai-action-figure-generator#howto' },
				{ '@id': 'https://liftapp.ai/ai-action-figure-generator#benefits' },
				{ '@id': 'https://liftapp.ai/ai-action-figure-generator#faq' },
				{ '@id': 'https://liftapp.ai/ai-action-figure-generator#why-lift' },
				{
					'@id': 'https://liftapp.ai/ai-action-figure-generator#explore-tools',
				},
				{ '@id': 'https://liftapp.ai/ai-action-figure-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-action-figure-generator#product',
			name: 'AI Action Figure Generator Online',
			description:
				"Turn your photos into collectible-style action figures with Lift's generator. Create viral-ready figurines with realistic packaging, dramatic poses, and toy-shelf aesthetics — no design skills required, no watermark.",
			url: 'https://liftapp.ai/ai-action-figure-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-action-figure-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI builds your action figure',
					text: 'Our AI transforms your photo into a collectible-style figurine with dynamic poses, realistic packaging, and toy-shelf lighting',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-action-figure-generator#benefits',
			name: 'Who can benefit from AI Action Figure Generator?',
			description:
				"Lift's AI Action Figure Generator is useful for content creators, social media users, collectors, toy enthusiasts, brands, and marketers.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Quick, creative, and premium-quality — ideal for personal fun',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Perfect for trending content creators who want viral-ready posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Social media users can join the AI action figure trend with unique, eye-catching content',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Collectors and toy enthusiasts can reimagine themselves as limited-edition figures',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Brands and marketers can create playful, shareable promotional content that stands out',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Action Figure Trend',
				description: 'AI Action Figure Trend',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-action-figure-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Action Figure Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Action Figure Generator is a online tool that transforms your photos into collectible-style action figures complete with toy packaging, dramatic poses, and shelf-ready aesthetics — perfect for social media trends or creative fun.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Action Figure Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo, detects facial features and body positioning, then reimagines you as a realistic action figure with custom packaging design, toy-style lighting, and collectible details. Everything happens automatically in seconds — no Photoshop skills needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I generate action figure from any type of image?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift works with portraits, objects, and virtually any image. The AI adapts to different photo types and automatically applies appropriate depth mapping, perspective adjustments, and dimensional effects that enhance visual impact while maintaining the integrity of your original content.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Absolutely. All images generated or edited in Lift can be exported without watermark when you are on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.',
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-action-figure-generator#why-lift',
			name: "Why Lift's AI Action Figure Generator stands out",
			description:
				"Lift's AI Action Figure Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'AI Action Figure Generator',
				description: 'AI Action Figure Generator',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-action-figure-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-action-figure-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Action Figure Generator',
					item: 'https://liftapp.ai/ai-action-figure-generator',
				},
			],
		},
	],
};
